export default __webpack_public_path__ + "static/item_01-d0aa4132041f292726fe9870d27db949.jpg";